<div class="ui-control ui-inline-control" [formGroup]="formGroup">
  <span class="input-label">{{inputData.label}}</span>
  <p-spinner class="input-control" size="30" [step]="inputData.inputAttributes.step" [formControlName]="inputData.colName"></p-spinner>
</div>
